// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".research_course_warp[data-v-d21f5626]{width:100%;height:100%;position:fixed;color:#333;overflow:hidden}.research_course_warp .research_course[data-v-d21f5626]{width:100%;height:calc(100% - 60px);height:100%;margin-top:60px}.research_course_warp .research_course .research_course_iframe[data-v-d21f5626]{width:100%;height:100%;border:none}", ""]);
// Exports
module.exports = exports;
